import { useEffect, useState } from "react";
import Loader from "react-loader-spinner";

function ConfirmPurchase({
  handleChangeTransferDetails,
  transferDetails,
  isProcessing,
  onConfirm,
}) {
  const [areFieldsSet, setAreFieldsSet] = useState(false);

  useEffect(() => {
    const isTransactionPinValid = /^\d{6}$/.test(
      transferDetails.transaction_pin
    );
    const areFieldsValid = Object.values(transferDetails).every(
      (value) => value !== ""
    );
    setAreFieldsSet(isTransactionPinValid && areFieldsValid);
  }, [transferDetails, transferDetails.transaction_pin]);

  return (
    <>
      <h2 className="mb-5 text-primary fw-bold">Confirm Data Purchase</h2>
      <div className="card shadow h-100 py-2">
        <div className="card-body">
          <h3 className="card-title text-muted">Confirm Purchase</h3>
          <form onSubmit={onConfirm}>
            <div className="form-group mb-3">
              <label className="form-label text-secondary">From Wallet</label>
              <input
                type="text"
                className="form-control mb-5"
                value={`${transferDetails.wallet_name} (${transferDetails.wallet_account_number})`}
                disabled
                readOnly
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label text-secondary">
                To Phone Number
              </label>
              <input
                type="text"
                className="form-control mb-5"
                value={`${transferDetails.phoneNumber} | ${transferDetails.network}`}
                disabled
                readOnly
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label text-secondary">Data Plan</label>
              <input
                type="text"
                className="form-control mb-5"
                value={`${JSON.parse(transferDetails.dataplan).DATAPLAN_DESC}`}
                disabled
                readOnly
              />
            </div>

            <hr />
            <p className="text-muted">
              To complete this transaction, provide your transaction PIN below.
            </p>

            <div className="form-group mb-5">
              <label
                className="form-label text-secondary"
                htmlFor="transactionPin"
              >
                Transaction PIN
              </label>

              <input
                type="password"
                name="transaction_pin"
                id="transactionPin"
                className="form-control mb-5"
                placeholder=""
                title="Numbers only"
                maxLength="6"
                pattern="[0-9]{6}"
                required
                onChange={handleChangeTransferDetails}
              />
            </div>
            <button
              className={`btn w-100 btn-primary lift ${
                areFieldsSet ? "" : "disabled"
              }`}
              type="submit"
              disabled={!areFieldsSet || isProcessing}
            >
              {isProcessing ? (
                <Loader type="Oval" color="#fff" width={20} height={20} />
              ) : (
                "Next"
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default ConfirmPurchase;
